const BLOCKED_SPORTS_KEY = "blockedSports";

function normalizeBlockedSports(value) {
  let sports = value;

  if (typeof sports === "string") {
    const trimmed = sports.trim();

    if (!trimmed) return [];

    try {
      const parsed = JSON.parse(trimmed);
      sports = Array.isArray(parsed) ? parsed : trimmed.split(",");
    } catch {
      sports = trimmed.split(",");
    }
  }

  if (!Array.isArray(sports)) return [];

  return [...new Set(sports.map((sportId) => String(sportId).trim()))].filter(
    Boolean
  );
}

export function getBlockedSports() {
  return normalizeBlockedSports(localStorage.getItem(BLOCKED_SPORTS_KEY));
}

export function setBlockedSports(value) {
  const previousSports = getBlockedSports();
  const blockedSports = normalizeBlockedSports(value);

  localStorage.setItem(BLOCKED_SPORTS_KEY, JSON.stringify(blockedSports));

  return JSON.stringify(previousSports) !== JSON.stringify(blockedSports);
}

export function isSportBlocked(sportId) {
  if (sportId === null || sportId === undefined || sportId === "") {
    return false;
  }

  return getBlockedSports().includes(String(sportId));
}

export function filterBlockedSports(items, getSportId = (item) => item?.id) {
  if (!Array.isArray(items)) return [];

  return items.filter((item) => !isSportBlocked(getSportId(item)));
}

